import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Lista de los usuarios seleccionados en la (des)activación masiva
export const Names = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  line-height: 1.6;
  color: ${tokens.color.text.secondary};
`
